import{APP_ERROR,PIPELINE_ERROR}from"../../constants/ActionTypes";/**
 * Creates the dispatched APP_ERROR action object.
 * @param {Object} error The error object.
 * @return {Object} The dispatched action object.
 */export var appError=function appError(error){return{type:APP_ERROR,error:error};};/**
 * Creates the dispatched PIPELINE_ERROR action object.
 * @param {Object} error The error object.
 * @return {Object} The dispatched action object.
 */export var pipelineError=function pipelineError(error){return{type:PIPELINE_ERROR,error:error};};